


















import { computed, defineComponent } from '@vue/composition-api';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';
import { BUTTON_EDITOR_PROPS } from './buttonEditor';
import BaseButtonEditor from './BaseButtonEditor.vue';
import HrefInputSection from '../editorSections/HrefInputSection.vue';

export default defineComponent({
	components: {
		BaseButtonEditor,
		HrefInputSection,
	},
	props: BUTTON_EDITOR_PROPS,
	setup(props, ctx) {
		const { doMetaInput } = useHighlightsInput(ctx, computed(() => props.value));
		return {
			doMetaInput,
		};
	},
});
